export class ReceiptGenerator {
  static generateReceipt = async (client, cart) => {
    const details = cart && cart.better_details ? cart.better_details.map((item, index) => {
      const sku = item.sku || 'Sin SKU';
      const name = item.label || item.name || 'Sin nombre';
      const price = item.common_price || 0;
      const amount = item.common_total || 0;
      const quantity = item.quantity || 0;
      const discountAmount = item.common_discount || 0;
      const discountPercent = price > 0 ? (discountAmount / price) * 100 : 0;
      return {
        "MontoItem": amount,
        "NroLinDet": index + 1,
        "CdgItems": [{ "TpoCodigo": "SKU", "VlrCodigo": sku }],
        "NmbItem": name,
        "QtyItem": quantity,
        "DescuentoPct": discountPercent,
        "DscItem": null,
        "PrcItem": price,
        "DescuentoMonto": discountAmount
      };
    }) : [];

    const receiver = {
      "RUTRecep": "66666666-6",
      "RznSocRecep": "cliente boleta"
    };

    const total = cart?.ticket_data?.amount || 0;
    const tax = cart?.ticket_data?.iva_amount || 0;
    const subtotal = total - tax;
    const totals = {
      "MntNeto": subtotal,
      "IVA": tax,
      "MntTotal": total
    };

    const document = {
      "IndServicio": 3
    };

    const custom = {
      "Almacen": cart?.ticket_data?.branch_address || 'Desconocido',
      "NOrden": cart?.ticket_data?.operation_id || 'Desconocido',
      "CajaReg": cart?.ticket_data?.terminal_id || 'Desconocido',
      "Tpago1": cart?.ticket_data?.card_brand || 'Desconocida',
      "MontPago1": total
    };

    const payload = {
      "Action": "gendoc",
      "Args": {
        "DocType": "Boleta",
        "Operation": {
          "Detalles": details,
          "Receiver": receiver,
          "Totals": totals,
          "IdDoc": document,
          "Personalizados": custom
        }
      }
    };

    const url = 'http://localhost:5175/generateReceipt';

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) throw new Error(`Receipt generation failed: ${response.status}`);
    return await response.json();
  };
  
  static consolidateReceipt = async (documentId) => {
    const payload = {
      "Action": "consolidate",
      "Args": {
        "DocId": documentId
      }
    };

    const url = 'http://localhost:5175/consolidateReceipt';

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) throw new Error(`Receipt consolidation failed: ${response.status}`);
    return await response.json();
  };
};